export default "__VITE_PUBLIC_ASSET__cdb4850a__"